import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=e9c112be&scoped=true"
import script from "./Mall.vue?vue&type=script&lang=js"
export * from "./Mall.vue?vue&type=script&lang=js"
import style0 from "./Mall.vue?vue&type=style&index=0&id=e9c112be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c112be",
  null
  
)

export default component.exports